export default "__VITE_ASSET__BGJf5vIZ__"